<template>
  <div class="page">
    <ion-grid fixed>
      <form @keyup.enter="saveCharger">
        <ion-row class="row-divider"></ion-row>
        <ion-row class="rectangle">
          <ion-col>
            <ion-row align-items-stretch>
              <ion-col class="col-padding">
                <ion-label class="section-head">Charging Station &amp; Charger</ion-label>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-row align-items-stretch>
                  <ion-col size="12">
                    <ion-label class="section-item" position="stacked">
                        Station ID
                        <span class="required">*</span>
                    </ion-label>
                    <div class="border-line-box-34 margin-top-10" v-if="!editmode">
                      <ion-input
                        class="form-input"
                        type="text"
                        placeholder="Enter Station Id"
                        @ionBlur="getStation"
                        @input="stationId = $event.target.value"
                        :value="stationId"
                        :readonly="editmode"
                      ></ion-input>
                      <span class="input-search-icon" @click="openStationModal">
                        <img src="/../assets/images/common/search/116836.png" />
                      </span>
                    </div>
                    <div class="section-desc margin-top-10" v-if="editmode">{{stationId}}</div>
                  </ion-col>
                  <ion-col size="12">
                      <ion-label class="section-item" position="stacked">Station Name</ion-label>
                      <div class="section-desc margin-top-10">{{station ? station.name : ''}}</div>
                  </ion-col>
                  <ion-col size="12">
                      <ion-label class="section-item" position="stacked">Status</ion-label>
                      <div
                          v-if="station"
                          class="section-desc margin-top-10"
                          v-bind:class="[{'status-active': station.status.id == 'A'}, {'status-inactive': station.status.id == 'I'}]"
                      >{{station ? convertUppercase(station.status.name) : ''}}</div>
                  </ion-col>
                </ion-row>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-row align-items-stretch>
                  <ion-col size="12">
                    <ion-label class="section-item" position="stacked">
                        Charger ID
                        <span class="required">*</span>
                    </ion-label>
                    <div class="border-line-box-34 margin-top-10" v-if="!editmode">
                      <ion-input
                        class="form-input"
                        type="text"
                        placeholder="Enter Charger Id"
                        @ionBlur="getCharger"
                        @input="chargerId = $event.target.value"
                        :value="chargerId"
                        :readonly="editmode"
                      ></ion-input>
                      <span class="input-search-icon" @click="openChargerModal">
                        <img src="/../assets/images/common/search/116836.png" />
                      </span>
                    </div>
                    <div class="section-desc margin-top-10" v-if="editmode">{{chargerId}}</div>
                  </ion-col>
                  <ion-col size="12">
                    <ion-label class="section-item" position="stacked">Manufacturer</ion-label>
                    <div class="section-desc margin-top-10">{{charger ? charger.manufacturer : ''}}</div>
                  </ion-col>
                  <ion-col size="12">
                    <ion-label class="section-item" position="stacked">Status</ion-label>
                    <div
                        v-if="charger"
                        class="section-desc status-small margin-top-10"
                        v-bind:class="[{'new': charger.status.id == 'A'}, {'new': charger.status.id == 'PND'}, {'new': charger.status.id == 'RMV'}, {'inactive': charger.status.id == 'RET'}, {'installed': charger.status.id == 'INS'}, {'installed': charger.status.id == 'I'}]"
                    >{{charger ? convertUppercase(charger.status.name) : ''}}</div>
                  </ion-col>
                </ion-row>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-row align-items-stretch>
                  <ion-col size="12">
                    <ion-label class="section-item" position="stacked">
                        Effective From
                    </ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                      <datepicker
                        class="form-vue-picker"
                        placeholder="DD/MON/YYYY"
                        inputFormat="dd/MMM/yyyy"
                        v-model="effectiveFrom"
                        :typeable="true"
                      ></datepicker>
                      <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                      </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                      <!-- <div class="input-icon-calendar"> -->
                      <!-- <ion-datetime
                        class="form-picker"
                        placeholder="Select From Date"
                        displayFormat="YYYY, MM, DD"
                        @ionChange="effectiveFrom = $event.target.value"
                      ></ion-datetime> -->
                      <datepicker
                        class= "form-picker"
                        placeholder= "Select From Date"
                        inputFormat="MMM dd, yyyy"
                        v-model= "effectiveFrom"
                        :typeable= "true"
                      ></datepicker>
                      <span class="input-icon-calendar">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                      </span>
                      <!-- </div> -->
                    </div>
                  </ion-col>
                  <ion-col size="12">
                    <ion-label class="section-item" position="stacked">
                        Last Effective Date
                    </ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                      <datepicker
                        class="form-vue-picker"
                        placeholder="DD/MON/YYYY"
                        inputFormat="dd/MMM/yyyy"
                        v-model="effectiveTo"
                        :typeable="true"
                      ></datepicker>
                      <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                      </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                      <!-- <div class="input-icon-calendar"> -->
                        <!-- <ion-datetime
                          class="form-picker"
                          placeholder="Select To Date"
                          displayFormat="YYYY, MM, DD"
                          @ionChange="effectiveTo = $event.target.value"
                        ></ion-datetime> -->
                        <datepicker
                          class= "form-picker"
                          placeholder= "Select To Date"
                          inputFormat="MMM dd, yyyy"
                          v-model= "effectiveTo"
                          :typeable= "true"
                        ></datepicker>
                        <span class="input-icon-calendar">
                          <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                      <!-- </div> -->
                    </div>
                  </ion-col>
                  <ion-col size="12">
                    <ion-label class="section-item" position="stacked">
                        Installation Status
                    </ion-label>
                    <div class="border-line-34 margin-top-10">
                      <ion-select
                        class="form-select select-mobile"
                        :value="installStatus"
                        @ionChange="installStatus = $event.target.value"
                        placeholder="Select Status"
                        interface="action-sheet"
                      >
                      <ion-select-option
                        v-for="(status, index) in this.installationStatuses"
                        :key="index"
                        :value="status.id"
                      >{{status.name}}</ion-select-option>
                      </ion-select>
                      <select
                        class="input-select select-web"
                        v-model="installStatus"
                        placeholder="Select Status"
                        >
                        <option
                          v-for="(status, index) in this.installationStatuses"
                          :key="index"
                          :value="status.id"
                        >{{ status.name }}</option>
                      </select>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
            <hr v-if="this.outlets && this.outlets.length > 0" />
            <hr class="thick-line" 
              v-if="this.outlets && this.outlets.length > 0"
            />
            <ion-row align-items-stretch
              v-if="this.outlets && this.outlets.length > 0"
              >
              <ion-col class="col-padding">
              <ion-label class="section-head">Designated Bay/Port No</ion-label>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch
              v-for="(outlet, outputIndex) in this.outlets"
              :key="outputIndex"
              >
              <ion-col
                size="12"
                size-md="12"
                class="col-padding"
                >
                <ion-row align-items-stretch>
                  <ion-col size="3">
                    <ion-label class="section-head">Output Name {{outputIndex + 1}}</ion-label>
                    <div class="border-line-34 margin-top-10">
                      <ion-input
                        class="form-input"
                        type="text"
                        placeholder="Enter Outlet Name"
                        @input="outlet.name = $event.target.value"
                        :value="outlet.name"
                        maxlength="100"
                      ></ion-input>
                    </div>
                  </ion-col>
                  <ion-col size="3"
                    v-for="(gun, gunIndex) in outlet.guns" :key="gunIndex"
                    >
                    <ion-label class="section-head">Port Name {{gunIndex + 1}}</ion-label>
                      <div class="border-line-34 margin-top-10">
                        <ion-input
                        class="form-input"
                        type="text"
                        placeholder="Enter gun Name"
                        @input="gun.name = $event.target.value"
                        :value="gun.name"
                        maxlength="100"
                        ></ion-input>
                      </div>
                  </ion-col>
                </ion-row>
                <ion-row align-items-stretch>
                  <ion-col class="col-padding">
                    <ion-grid>
                      <ion-row>
                        <ion-col class="section-head">
                            <b>Tariff</b>
                        </ion-col>
                        <ion-col class="section-head">
                            <b>Effective From Date</b>
                        </ion-col>
                        <ion-col class="section-head">
                            <b>Last Effective Date</b>
                        </ion-col>
                        <ion-col></ion-col>
                      </ion-row>
                      <ion-row 
                        v-for="(tariff, tariffIndex) in outlet.tariffs"
                        :key="tariffIndex"
                        >
                        <ion-col>
                          <div class="border-line-34 margin-top-10">                        
                            <select  v-if="tariff.id == 0" 
                              class="input-select select-web"
                              v-model="outlets[outputIndex].tariffs[tariffIndex].tariffCode"
                              placeholder="Select Tariff"
                              >
                              <option
                              v-for="(tariff, index) in tariffs"
                              :key="index"
                              :value="tariff.id"
                              >{{tariff.name}}</option>
                            </select>
                            <label v-if="tariff.id != 0" v-bind:class="[{'inactive-tariff-column section-desc' : tariff.status.id == 'I'}, {'section-desc' : tariff.status.id != 'I'}]">{{tariff.tariffCode}}</label>
                          </div>
                        </ion-col>
                        <ion-col>
                          <div v-if="tariff.id != 0" class="date-picker-box margin-top-10 datepicker-web">
                            <label v-bind:class="[{'inactive-tariff-column section-desc' : tariff.status.id == 'I'}, {'section-desc' : tariff.status.id != 'I'}]">{{changeDateFormatWithoutTime(tariff.effectiveOn)}}</label>
                          </div>
                          <div v-if="tariff.id == 0" class="date-picker-box margin-top-10 datepicker-web">
                            <datepicker
                                class="form-vue-picker"
                                placeholder="DD/MON/YYYY"
                                inputFormat="dd/MMM/yyyy"
                                v-model="outlets[outputIndex].tariffs[tariffIndex].effectiveOn"
                                :typeable="true"
                            ></datepicker>
                            <span class="custom-calendar-icon">
                            <img src="/../assets/images/common/datepicker/calendar.png" />
                            </span>
                          </div>
                        </ion-col>
                        <ion-col>
                          <div v-if="tariff.status.id == 'I'"  class="date-picker-box margin-top-10 datepicker-web">
                              <label class="inactive-tariff-column section-desc">{{changeDateFormatWithoutTime(tariff.effectiveTill)}}</label>
                          </div>
                          <div v-if="tariff.status.id != 'I'" class="date-picker-box margin-top-10 datepicker-web">
                            <datepicker
                              class="form-vue-picker"
                              placeholder="DD/MON/YYYY"
                              inputFormat="dd/MMM/yyyy"
                              v-model="outlets[outputIndex].tariffs[tariffIndex].effectiveTill"
                              :typeable="true"
                            ></datepicker>
                            <span class="custom-calendar-icon">
                              <img src="/../assets/images/common/datepicker/calendar.png" />
                            </span>
                          </div>
                        </ion-col>
                        <ion-col>
                          <ion-row>
                            <ion-col size="1" v-if="outlets[outputIndex].tariffs[tariffIndex].id == 0 && outlets[outputIndex].tariffs.length > 1">
                              <ion-fab-button class="fab-delete fab-btn" @click="deleteTariffRow(outputIndex, tariffIndex)">
                                <ion-icon :icon="trash"></ion-icon>
                              </ion-fab-button>
                            </ion-col>
                            <ion-col size="1" v-if="(tariffIndex == (outlets[outputIndex].tariffs.length - 1)) || outlets[outputIndex].tariffs.length <= 1">
                              <ion-fab-button class="fab-primary fab-btn" @click="addNewTariffRow(outputIndex)">
                                <ion-icon :icon="add"></ion-icon>
                              </ion-fab-button>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-grid>                
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12" size-md="3" class="col-padding">
                    <ion-label class="section-item" position="stacked">CMS Tag No</ion-label>
                      <div class="section-desc margin-top-10">{{stationId+'-'+chargerId+'-'+(outputIndex + 1)}}</div>
                  </ion-col>
                  <ion-col size="12" size-md="3" class="col-padding">
                    <ion-label class="section-item" position="stacked">QR Code</ion-label><br>
                    <qrcode-vue v-bind:value="getEncrpQR(stationId+'-'+chargerId+'-'+(outputIndex + 1))" size="50"></qrcode-vue>
                  </ion-col>
                </ion-row>
                <hr class="thick-line" />
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <ion-row align-items-stretch>
          <ion-col size="12" class="col-nopadding ion-text-right">
            <ion-button class="btn-primary" @click="cancel">Cancel</ion-button>
            <ion-button class="btn-primary" @click="saveCharger">Save</ion-button>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
    <div class="spinner">
        <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner, modalController } from "@ionic/vue";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVChargerService } from "../../service/evcstation/charger.service";
import { EVCharger } from "../../entity/station/evcharger";
import {
  EVCStationBaySetup,
  EVCBayOutlet,
  EVCBayOutletGun,
  EVCBayOutletTariff,
  EVCStationBayStatus
} from "../../entity/station/evcbay";
import { EVChargeTariff } from "../../entity/station/evcharge-tariff";
import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import StationModal from "./ChargingStationsModel.vue";
import ChargerModal from "./ChargersModel.vue";
import QrcodeVue from 'qrcode.vue';
import Index from '@/views/Index.vue';
import moment from "moment";
import { add, trash } from 'ionicons/icons';

export default defineComponent ({
  name: 'chargerDetail',
  components: {
      datepicker, IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner,QrcodeVue, modalController
  },
  data() {
    return {
      add,
      trash,
      QrcodeVue,
      effectiveToDummy : "01/Jul/2020",
      loaderTab: true,
      editmode: false,
      mode: "ADD",
      bayId: "",
      stationId: "",
      chargerId: "",
      effectiveFrom: "",
      effectiveTo: "",

      station: null,
      charger: null,
      status: "",
      installStatus: "",

      outlets: [],
      tariffs: [],
      statuses: [],
      installationStatuses: []
    }
  },
  async mounted() {
    try {
      let bayStationInfo = JSON.parse(localStorage.getItem("bayStationInfo"))

      this.installationStatuses = await new EVCStationService().installationStatuses();
      this.statuses = await new EVCStationService().stationStatuses();
      this.tariffs = await new EVChargerService().chargerTariffs();

      if (bayStationInfo != null && bayStationInfo.bayId) {
        let baySetup = await new EVCStationService().baySetupWithIdOfStation(
          bayStationInfo.bayId,
          { id: bayStationInfo.stationId }
        );
        this.fillChargerBaySetup(baySetup);
      }
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },
  methods: {
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    changeDateFormatWithoutTime(dateValue) {
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
    },
    convertUppercase(value) {
      return value.toUpperCase()
    },
    tariffChanged(outputIndex, tariffIndex, $e){
      //console.log("Event Fired :", outputIndex, tariffIndex, $e);
    },
    deleteTariffRow(outputIndex, tariffIndex){
      this.outlets[outputIndex].tariffs.splice(tariffIndex, 1);
    },
    addNewTariffRow(outputIndex){
      this.outlets[outputIndex].tariffs.push(new EVCBayOutletTariff(0, "", "", ""));
    },
    getInputDate(e){
      return new Date(e);
    },
    getEncrpQR(qrCode) {
      let encrpQR = btoa(qrCode);
      return encrpQR;
    },
    async getStation() {
      this.loaderTab = true;
      try {
        this.station = null;
        if (this.stationId && this.stationId.toString().trim() != '' && Number.isInteger(+this.stationId.toString().trim()) ) {
          this.station = await new EVCStationService().stationWithId(
            parseInt(this.stationId.toString().trim())
          );
        }
      } catch (error) {
        new ToastUtils().presentToast(error);
      } finally {
        this.loaderTab = false;
      }
    },

    async getCharger() {
      this.loaderTab = true;
      try {
        this.charger = null;
        if (this.chargerId && this.chargerId.toString().trim() != '' && Number.isInteger(+this.chargerId.toString().trim())) {
          this.charger = await new EVChargerService().chargerWithId(
            parseInt(this.chargerId.toString().trim())
          );
          this.outlets = [];
          this.charger.outputs.forEach((output,Index) => {
            let guns = [];
            output.ports.forEach(port => {
              guns.push(new EVCBayOutletGun(port.id, ""));
            });
            this.outlets.push(
              new EVCBayOutlet("", "", output, guns, new EVChargeTariff("", ""), [new EVCBayOutletTariff(0, "", new Date(), new Date(9999,11,31))],btoa(this.stationId+'-'+this.chargerId+'-'+(Index+1)),(this.stationId+'-'+this.chargerId+'-'+(Index+1)))
            );
          });
        }
      } catch (error) {
        // new ToastUtils().presentToast(error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      } finally {
        this.loaderTab = false;
      }
    },

    async openStationModal() {
      localStorage.removeItem("stationSearch")
      const modal = await modalController.create({
        component: StationModal,
        componentProps: {
          methods: {
            viewStation(stationId) {
              modal.dismiss(stationId);
            }
          }
        },
        // cssClass: "modal-fullscreen"
      });
      // modal.cssClass = "modal-fullscreen"
      modal.onDidDismiss().then(data => {
        if(data.role != "backdrop") {
          this.stationId = data["data"]; // Here's your selected user!
          this.getStation();
        } else {
          this.stationId = null;
        }
        
      });
      return await modal.present();
    },
    async openChargerModal() {
      const modal = await modalController.create({
        component: ChargerModal,
        componentProps: {
          methods: {
            viewCharger(chargerId) {
              modal.dismiss(chargerId);
            }
          }
        },
        // cssClass: "modal-fullscreen"
      });
      modal.onDidDismiss().then(data => {
        if(data.role != "backdrop") {
          this.chargerId = data["data"];
          this.getCharger();
        } else {
          this.chargerId = null;
        }
        
      });
      return await modal.present();
    },

    fillChargerBaySetup(baySetup) {
      this.editmode = true;
      this.mode = "UPDATE";
      this.bayId = baySetup.id;
      this.stationId = baySetup.station.id;
      this.chargerId = baySetup.charger.id;
      this.station = baySetup.station;
      this.charger = baySetup.charger;
      this.outlets = baySetup.outlets;
      this.effectiveFrom = baySetup.effectiveOn;
      this.effectiveTo = baySetup.effectiveTill;
      this.installStatus = baySetup.status.id;
    },

    cancel() {
      this.$router.back();
    },

    async saveCharger() {
      try {
        if (
        typeof this.stationId === "undefined" ||
        this.stationId === null ||
        this.stationId === "" ||
        this.station === null
      ) {
        new ToastUtils().presentToast("Enter valid Station ID");
      } else if (
        typeof this.chargerId === "undefined" ||
        this.chargerId === null ||
        this.chargerId === "" ||
        this.charger === null
      ) {
        new ToastUtils().presentToast("Enter valid Charger ID");
      } else {
        let baydtl = null;
        if (this.mode === "ADD") {
          let bay = new EVCStationBaySetup(
            "",
            this.station,
            this.charger,
            this.outlets,
            new EVCStationBayStatus(this.installStatus, ""),
            this.effectiveFrom,
            this.effectiveTo
          );
          baydtl = await new EVCStationService().setupBayOnStationWithChargerByAuthor(
            bay,
            this.station,
            new LocalStorage().user
          );
        } else {
          let bay = new EVCStationBaySetup(
            this.bayId,
            this.station,
            this.charger,
            this.outlets,
            new EVCStationBayStatus(this.installStatus, ""),
            this.effectiveFrom,
            this.effectiveTo
          );
          
          baydtl = await new EVCStationService().reSetupBayOnStationWithChargerByAuthor(
            bay,
            this.station,
            new LocalStorage().user
          );
        }

        new ToastUtils().presentToast(
          "Charger Installation saved successfully"
        );
        this.$router.back();
      }
      } catch(error) {
        // new ToastUtils().presentToast(error.response.data.errors[0].detail)
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    }
  }
})
</script>

<style scoped>
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
.fab-btn {
  width: 20px;
  height: 20px;
  margin-top: 5px;
}
.inactive-tariff-column{
  color: #ff0000 !important;
}
</style>